import angular from 'angular';

import Component from './events-schedule.component';

const Module = angular
    .module('control-room.events.components.events-schedule', [])
    .component('crEventsSchedule', Component);

export default Module;
